import React, { useState, useEffect } from "react";
import { Typography, Grid2, Button, useMediaQuery, Box } from "@mui/material";
import { useTheme } from "@mui/material";

import TBlogo from "../../Assets/Images/LoginTradeBossLogo.svg";
import bull from "../../Assets/Images/TB_loginLogo.svg";
import HomeLandingVideo from "../../Assets/Home_Landing_video_Login.mp4";
import backgroundImage from "../../Assets/Images/MaskGroup.png"; // Adjust the path

import styles from "./SignUpWeb.module.css"; // Import the CSS module

const SignUpWeb = () => {
  //   const theme = useTheme();
  // const range = useMediaQuery(theme.breakpoints.between(601, 849));

  const isLargeScreen = useMediaQuery("(max-width:1564px)");
  const screenWidth1300 = useMediaQuery("(max-width:1300px)");

  const handleLogin = () => {
    console.log("clicked");

  };

  return (
    <Box className={styles.HomeSectionBox}>
      <video
        src={HomeLandingVideo}
        autoPlay
        muted
        loop
        playsinline="true"
      ></video>
      <Box className={styles.LogingradientBackground}></Box>
      <Grid2
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid2
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            gap: "5rem",
          }}
        >
          <Grid2
            style={{
              width: "58%",
              minHeight: "700px",
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
            }}
          >
            <Grid2
              container
              style={{
                // background:
                //   "radial-gradient(74.53% 74.53% at 50% 50%, #090227 43%, rgba(69, 30, 98, 0) 99.99%)",
                background: "#0E020399",

                height: isLargeScreen ? "700px" : "750px",
                width: "80%",
                borderRadius: "28px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={TBlogo}
                alt="Logo"
                style={{
                  width: screenWidth1300 ? "300px" : "345px",
                  height: "auto",
                }}
              />
            </Grid2>
          </Grid2>

          <Grid2
            style={{
              width: "68%",
              minHeight: "700px",
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            <Grid2
              container
              style={{
                height: isLargeScreen ? "700px" : "750px",
                backgroundImage: `url(${backgroundImage})`, // Use the imported image
                backgroundSize: "cover", // Ensure the image covers the entire container
                backgroundPosition: "center", // Center the image
                // border: window.innerWidth < 849 ? "none" : "none",
                padding: "25px 25px 25px",
                width: "90%",
                borderRadius: "28px",
              }}
            >
              <Grid2
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={bull}
                  alt="bulllogo"
                  width={screenWidth1300 ? "500px" : "577px"}
                ></img>
              </Grid2>
              <Grid2
                style={{
                  width: "70%",
                  marginTop: "3%",
                  marginLeft: "15%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography className={styles.card_tit}>Sign Up</Typography>
              </Grid2>

              {/* Login Button */}
              {/* <Grid2
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Grid2
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <Button
                    fullWidth
                    className={styles.joinDiplomtsBtn}
                    style={{ marginTop: "20px" }}
                    onClick={() => handleLogin}
                  >
                    Sign Up
                  </Button>
                </Grid2>
              </Grid2> */}

              {/* Register Link */}
              <Grid2
                style={{
                  marginTop: "3%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "47px",
                }}
              >
                <Typography className={styles.d3}>
                 Have an account
                </Typography>
                <Typography
                  className={styles.d4}
                  sx={{ marginLeft: "1%", cursor: "pointer !important" }}
                >
                  Login
                </Typography>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default SignUpWeb;
